<template>
  <div class="card">
    <div class="card-header pb-0">
      <!-- <h6>Data Jemaat</h6> -->
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="row p-3" v-if="isAdmin">
        <div class="col-md-12">
          <label for="example-text-input" class="form-control-label"
            >Nama Jemaat</label
          >
          <VueMultiselect
            v-model="jemaat"
            :options="data_jemaat"
            :multiple="false"
            :close-on-select="true"
            placeholder="Pilih"
            label="NAMA"
            track-by="NAMA"
          />
        </div>
        <div class="col-md-12 mb-3">
          <label for="example-text-input" class="form-control-label"
            >Peran</label
          >
          <VueMultiselect
            v-model="peran"
            :options="data_statusKeluarga"
            :multiple="false"
            :close-on-select="true"
            placeholder="Pilih"
            label="nama"
            track-by="nama"
          />
        </div>
        <div class="col-md-12 mb-3">
          <argon-button size="sm" full-width @click="save()">Tambah Data</argon-button>
        </div>
      </div>
      <div class="table-responsive p-2">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nama Anggota</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Peran</th>
              <!-- <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telp / HP</th> -->
              <th v-if="isAdmin" class="text-secondary opacity-7" style="text-align: center"></th>
            </tr>
          </thead>
          <tbody>
            <tr :key="item.id" v-for="(item, index) in items">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column">
                    <h6 class="mb-0 text-sm">{{(parseInt(index) + 1)}}</h6>
                  </div>
                </div>
              </td>
              <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.NAMA}}</h6>
              </td>
              <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.field_peran.nama}}</h6>
              </td>
              <!-- <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.TELP}}</h6>
              </td> -->
              <td style="text-align: center" v-if="isAdmin">
                <argon-button variant="outline" size="sm" style="margin-right:10px" @click="editData(item.id)">Edit</argon-button>
                <argon-button variant="outline" size="sm" @click="remove(item.id)">Hapus</argon-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <v-pagination
          v-model="page"
          :pages="maxPage"
          :range-size="1"
          active-color="#DCEDFF"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import ArgonButton from "@/components/ArgonButton.vue";
  import VPagination from "@hennge/vue3-pagination";
  import VueMultiselect from 'vue-multiselect'
  import "@hennge/vue3-pagination/dist/vue3-pagination.css";
  export default {
    name: "anggota-keluarga-table",
    components: {
      ArgonButton,
      VPagination,
      VueMultiselect
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      }
    },
    created() {

    },
    watch: {
      page(newValue){
        console.log(newValue)
        this.axios.get(process.env.VUE_APP_API_URL + "keluarga?search="+this.search+"&page="+this.page, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          console.log(resp)
          this.page = resp.data.data.current_page
          this.maxPage = resp.data.data.last_page
          this.items = resp.data.data.data
        })
      },
      search(newVal){
        this.debouncedWatch(newVal);
      }
    },
    methods: {
      editData(id){
        this.$router.push({
          name: "Edit Data Jemaat", 
          params: { id: id }, 
        })
      },
      getWilayah(value) {
        if (value == 0 || value == null) return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.wilayah.filter(x => x.id == value)))[0].wilayah
      },
      getSektor(value) {
        if (value == 0 || value == null) return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.sektor.filter(x => x.id == value)))[0].nama
      },
      getStatus(value) {
        if (value == "0" || value == null || value == '') return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.status.filter(x => x.id == value)))[0].nama
      },
      roundUpNearest10(num) {
        return Math.ceil(num / 10) * 10;
      },
      roundDownNearest10(num) {
        return Math.ceil(num / 10) * 10;
      },
      remove(id){
        this.axios.post(process.env.VUE_APP_API_URL + "keluarga/anggota/remove", {
          "id" : id,
          "ID_KELUARGA" : "",
          "PERAN" : "",
        }, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then(()=>{
          this.$toast.open({
            message: 'Data Tersimpan!',
            type: 'success',
          });   
          this.axios.get(process.env.VUE_APP_API_URL + "jemaat/anggota", {headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
          }}).then((resp) => {
            this.data_jemaat = resp.data.data
          })
          this.axios.get(process.env.VUE_APP_API_URL + "keluarga/anggota/"+this.$route.params.id, {headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
          }}).then((resp) => {
            this.page = resp.data.data.current_page
            this.maxPage = resp.data.data.last_page
            this.items = resp.data.data.data
          })       
        }).catch((ex) => {
          console.log(ex)
          this.$toast.open({
              message: 'Terjadi Kesalahan, cek Console!',
              type: 'error',
          });
        })
      },
      save(){
        this.axios.post(process.env.VUE_APP_API_URL + "keluarga/anggota/add", {
          "id" : JSON.parse(JSON.stringify(this.jemaat)).id,
          "ID_KELUARGA" : this.$route.params.id,
          "PERAN" : JSON.parse(JSON.stringify(this.peran)).id,
        }, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then(()=>{
          this.$toast.open({
            message: 'Data Tersimpan!',
            type: 'success',
          });
          this.jemaat = ""
          this.peran = ""
          this.axios.get(process.env.VUE_APP_API_URL + "jemaat/anggota", {headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
          }}).then((resp) => {
            this.data_jemaat = resp.data.data
          })
          this.axios.get(process.env.VUE_APP_API_URL + "keluarga/anggota/"+this.$route.params.id, {headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
          }}).then((resp) => {
            this.page = resp.data.data.current_page
            this.maxPage = resp.data.data.last_page
            this.items = resp.data.data.data
          })
        }).catch((ex) => {
          console.log(ex)
          this.$toast.open({
              message: 'Terjadi Kesalahan, cek Console!',
              type: 'error',
          });
        })
      },
    },
    data() {
      return {
        data_statusKeluarga: '',
        data_jemaat: '',
        jemaat: '',
        peran: '',
        items: '',
        page: 1,
        maxPage: 1,
        search: '',
      }
    },
    mounted(){
      this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then((resp) => {
        this.data_statusKeluarga = JSON.parse(JSON.stringify(resp.data)).statusKeluarga
        this.status = JSON.parse(JSON.stringify(resp.data.status))
        this.axios.get(process.env.VUE_APP_API_URL + "jemaat/anggota", {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          this.data_jemaat = resp.data.data
        })
        this.axios.get(process.env.VUE_APP_API_URL + "keluarga/anggota/"+this.$route.params.id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          this.page = resp.data.data.current_page
          this.maxPage = resp.data.data.last_page
          this.items = resp.data.data.data
        })
      })
      
    }
  };
</script>
